// extracted by mini-css-extract-plugin
export default {"customElementContainer":"ListItem_customElementContainer__iViPK"};